/* eslint-disable react/prop-types */ // TODO: add props
import styles from './AnonymizerToggle.scss';
import cx from 'classnames';

const AnonymizerToggle = ({
  visible = true,
  isAnonymized,
  anonymizeProfiles,
  deanonymizeProfiles,
}) => {
  if (!visible) {
    return null;
  }
  const handler = isAnonymized ? deanonymizeProfiles : anonymizeProfiles;
  return (
    <div
      data-test="anonymizerToggle"
      role="button"
      onClick={handler}
      className={cx(styles.anonymizerToggle, {
        [styles.isAnonymized]: isAnonymized,
      })}
    >
      {isAnonymized ? 'Display real names' : 'Anonymise student names'}
    </div>
  );
};

export default AnonymizerToggle;
